const SUPPORTED_COMMODITY_IDS = [1, 2];

const normalizedCommodityId = (value) => {
  const commodityId = Number(value);
  return SUPPORTED_COMMODITY_IDS.includes(commodityId) ? commodityId : null;
};

export const getUtilityStateCommodityIds = (row = {}) => {
  const mappings = row.commodityMappings ?? row.CommodityMappings;
  if (Array.isArray(mappings) && mappings.length) {
    return [...new Set(mappings
      .map((mapping) => normalizedCommodityId(mapping.commodityId ?? mapping.CommodityId))
      .filter(Boolean))].sort();
  }

  const commodityId = Number(row.commodityId ?? row.CommodityId ?? 0);
  if (SUPPORTED_COMMODITY_IDS.includes(commodityId)) return [commodityId];

  const electric = Boolean(row.electric ?? row.Electric) || commodityId === 3 || commodityId === 5;
  const gas = Boolean(row.gas ?? row.Gas ?? row.natGas ?? row.NatGas) || commodityId === 3 || commodityId === 5;
  return [electric && 1, gas && 2].filter(Boolean);
};

const commodityRow = (row, commodityId, isCommodityProjection) => {
  const mappings = row.commodityMappings ?? row.CommodityMappings;
  const selectedMappings = Array.isArray(mappings)
    ? mappings.filter((mapping) => Number(mapping.commodityId ?? mapping.CommodityId) === commodityId)
    : null;
  const selectedMappingId = selectedMappings?.[0]?.id ?? selectedMappings?.[0]?.Id;
  const electric = commodityId === 1;
  const gas = commodityId === 2;

  return {
    ...row,
    isCommodityProjection,
    ...(selectedMappingId != null && {
      id: selectedMappingId,
      Id: selectedMappingId,
    }),
    commodityId,
    CommodityId: commodityId,
    electric,
    Electric: electric,
    gas,
    Gas: gas,
    natGas: gas,
    NatGas: gas,
    ...(Array.isArray(mappings) && {
      commodityMappings: selectedMappings,
      CommodityMappings: selectedMappings,
    }),
  };
};

export const expandUtilityStateRows = (rows = []) => rows.flatMap((row) => {
  const commodityIds = getUtilityStateCommodityIds(row);
  const isCommodityProjection = commodityIds.length > 1;
  return commodityIds.map((commodityId) => commodityRow(row, commodityId, isCommodityProjection));
});
